import React from "react";
import { Modal, ModalBody, ModalHeader, ListGroup, ListGroupItem, Button } from '@/Components/ui';
;
import { useNavigate } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { API_USER_PRECOUPON, API_PRECOUPON, BACKEND_HOST, getDataFromUrl, postData, getCookie, API } from "../../../api";
import moment from "moment";
import { dialogService } from "@/utils/dialogService";
const STATE_MODAL_FOCUS = {
    0: "사용처리",
    1: "사용취소",
};
const UserDetailPrecouponList = (props) => {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => { console.log(e); });
    };
    React.useEffect(() => {
        if (!previous && !next) {
            getDataFromUrl(`${API_USER_PRECOUPON}/?search=${props.userPhoneNum}`)
                .then((data) => {
                // console.log(data);
                setData(data.results);
                setPrevious(data.previous);
                setNext(data.next);
                setCount(data.count);
            })
                .catch((e) => { console.log(e); });
        }
    }, []);
    const cancelPreCouponItem = async (id) => {
        postData(`${BACKEND_HOST}/precoupon/unuse-coupon/${id}/`, { user_coupon_id: id }, "PUT")
            .then((res) => {
            console.log(res);
            // alert("사용취소 완료");
        })
            .catch(async (e) => {
            console.log(e);
            await dialogService.handleAlert("사용취소 실패", { force: "error" });
        });
    };
    const changePreCouponItem = async (id) => {
        // pass
    };
    const deletePreCouponItem = async (id) => {
        postData(`${API_PRECOUPON}/cancel-coupon-crm/`, { user_coupon_id: id }, "POST")
            .then((res) => {
            console.log(res);
            // alert("삭제 완료");
        })
            .catch(async (e) => {
            console.log(e);
            await dialogService.handleAlert("삭제 실패", { force: "error" });
        });
    };
    const refundPreCouponItem = async (id) => {
        const _precoupon = data.find((item) => item.id === id);
        if (!_precoupon)
            return;
        const _ticket_id = _precoupon.transfered_ticket?.id;
        // console.log("refundPreCouponItem", _ticket_id, _precoupon);
        if (!_ticket_id) {
            deletePreCouponItem(id);
            return null;
        }
        const response = await API.post(`${BACKEND_HOST}/ticket/cancel-ticket-crm/`, {
            id: _ticket_id,
            cancel_reason: "관리자취소",
        });
        return response.data;
    };
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [stateChangeModal, setStateChangeModal] = React.useState(false);
    const [focusState, setFocusState] = React.useState(-1); // 0 : "사용처리", 1 : "사용취소"
    const [deleteModal, setDeleteModal] = React.useState(false);
    const togStateChangeModal = () => setStateChangeModal(!stateChangeModal);
    const togDeleteModal = () => setDeleteModal(!deleteModal);
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id}/>;
            },
            id: '#',
        },
        //"id", "precoupon", "user", "reservation", "state", "expire_date", "created_at", "updated_at", "subdomain", "sitename",]
        {
            Header: 'ID',
            accessor: 'id',
            id: 'id',
        },
        {
            Header: '사용자',
            accessor: 'username',
            id: 'user__username',
            Cell: (cellProps) => {
                return <div>{cellProps.row.original["username"]}({cellProps.row.original["phone_num"]})</div>;
            }
        },
        {
            Header: '예약권명',
            accessor: 'precoupon_name',
            id: 'precoupon__name',
        },
        {
            Header: '제한금액',
            accessor: 'discount',
            id: 'discount',
        },
        {
            Header: '만료일',
            accessor: 'expire_date',
            id: 'expire_date',
            Cell: (cellProps) => {
                return <>{cellProps.row.original["expire_date"] ? moment(cellProps.row.original["expire_date"]).format("YYYY-MM-DD") : null}</>;
            }
        },
        {
            Header: '상태',
            accessor: 'state',
            id: 'state',
        },
        {
            Header: '예약(사용시)',
            accessor: 'reservation',
            id: 'reservation',
            Cell: (cellProps) => {
                return <>{cellProps.row.original["reserv_id"] ? <div>{cellProps.row.original["reserv_id"]} {cellProps.row.original["reserv_name"]} {cellProps.row.original["reserv_start_date"]} {cellProps.row.original["reserv_spot"]}번</div> : null}</>;
            }
        },
        {
            Header: 'Actions',
            accessor: 'Actions',
            id: '',
            Cell: (cellProps) => {
                return (<div className="d-flex gap-2">
                            {/* {(cellProps.row.original["상태"] !== "사용함") && <div className="edit">
                        <div className="text" style={{ cursor: "pointer", color: "#3577f1" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            togStateChangeModal(); setFocusState(0)
                        }}>
                            <i className="ri-pencil-fill fs-16"></i>
                        </div>
                    </div>} */}
                            {(cellProps.row.original["state"] !== "사용안함") && <div className="edit">
                                <div className="text" style={{ cursor: "pointer", color: "#ffbe0b" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            togStateChangeModal();
                            setFocusState(1);
                        }}>
                                    <i className="ri-pencil-fill fs-16"></i>
                                </div>
                            </div>}
                            <div className="remove">
                                <div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        setCheckedRecords([cellProps.row.original]);
                        togDeleteModal();
                    }}>
                                    <i className="ri-delete-bin-5-fill fs-16"></i>
                                </div>
                            </div>
                        </div>);
            }
        },
    ], []);
    const clearSelectedOptions = () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        const checkall = document.getElementById("checkBoxAll");
        ele.forEach((element) => {
            element.checked = false;
        });
        checkall.checked = false;
        setFocusState(-1);
    };
    const deleteRecords = async () => {
        if (await dialogService.confirm("예약권을 삭제하시겠습니까? 티켓과 연결된 경우 티켓도 함께 삭제됩니다.(환불안됨)") === false)
            return;
        (async () => {
            for (let i = 0; i < checkedRecords.length; i++) {
                const record = checkedRecords[i];
                await deletePreCouponItem(record.id);
            }
            await dialogService.handleAlert("삭제 완료");
        })()
            .then(() => history.go(0))
            .catch((e) => console.log(e));
    };
    const refundPrecoupons = async () => {
        if (await dialogService.confirm("예약권과 연결된 티켓이 환불됩니다.") === false)
            return;
        (async () => {
            for (let i = 0; i < checkedRecords.length; i++) {
                const record = checkedRecords[i];
                await refundPreCouponItem(record.id);
            }
            await dialogService.handleAlert("삭제 완료");
        })()
            .then(() => {
            history.go(0);
        })
            .catch((e) => console.log(e));
    };
    const changeState = () => {
        (async () => {
            if (focusState === 0) {
                // checkedRecords.forEach((record, idx, arr) => {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["state"] === "사용안함") {
                        await changePreCouponItem(record.id);
                    }
                }
                await dialogService.handleAlert("사용처리 완료");
            }
            else if (focusState === 1) {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["state"] === "사용완료") {
                        await cancelPreCouponItem(record.id);
                    }
                }
                await dialogService.handleAlert("사용취소 완료");
            }
        })()
            .then(() => history.go(0))
            .catch((e) => console.log(e));
    };
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    return (<React.Fragment>
            <div>
                <React.Fragment>
                    <ServerPaginatedTable url={API_USER_PRECOUPON} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} serachable={false} categories={[]}/>
                </React.Fragment>
            </div>


            {/* Modals */}

            {/* 예약권 상태 전환 Modal */}
            <Modal id="topmodal" isOpen={stateChangeModal} onClose={() => { clearSelectedOptions(); togStateChangeModal(); }}>
                <ModalHeader className="modal-title" id="myModalLabel" toggle={() => { clearSelectedOptions(); togStateChangeModal(); }}>
                    {STATE_MODAL_FOCUS[focusState]}
                </ModalHeader>
                <ModalBody className="text-center p-5">
                    <div className="mt-4">
                        <h6 className="mb-3">{`선택하신 사용자의 예약권을 모두 ${STATE_MODAL_FOCUS[focusState]}하시겠습니까?`}</h6>
                        <p className="text-muted mb-4">{(focusState === 0) ? '"사용안함"인 예약권만 "사용함"으로 변경됩니다.' : '"사용함"인 예약권만 "사용안함"으로 변경됩니다.'}</p>
                        {(checkedRecords.length > 0) ?
            <div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
                                    <ListGroup>
                                        {checkedRecords.map((record) => {
                    return (<ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["username"]}(${record["phone_num"]}) - ${record["precoupon_name"]}`}</ListGroupItem>);
                })}
                                    </ListGroup>
                                </div> :
            <span>{`${STATE_MODAL_FOCUS[focusState]}할 사용자 예약권을 먼저 선택해주세요.`}</span>}
                        <br />
                        <br />
                        <div className="hstack gap-2 justify-content-center">
                            <button className={(focusState === 0) ? "btn btn-soft-secondary fw-medium" : "btn btn-soft-warning fw-medium"} onClick={() => { clearSelectedOptions(); togStateChangeModal(); }}><i className="ri-close-line me-1 align-middle"></i> Close</button>
                            <button className={(focusState === 0) ? "btn btn-secondary" : "btn btn-warning"} onClick={() => { changeState(); setStateChangeModal(false); }} disabled={checkedRecords.length === 0}>{STATE_MODAL_FOCUS[focusState]}</button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            {/* Delete Modal */}
            <Modal id="topmodal" isOpen={deleteModal} onClose={() => { clearSelectedOptions(); togDeleteModal(); }}>
                <ModalHeader className="modal-title" id="myModalLabel" toggle={() => { clearSelectedOptions(); togDeleteModal(); }}>
                    삭제하기
                </ModalHeader>
                <ModalBody className="text-center p-5">
                    <div className="mt-4">
                        <h5 className="mb-3">선택하신 사용자의 예약권을 모두 삭제하시겠습니까?</h5>
                        {/* <p className="text-muted mb-4"> The transfer was not successfully received by us. the email of the recipient wasn't correct.</p> */}
                        {(checkedRecords.length > 0) ?
            <div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
                                    <ListGroup>
                                        {checkedRecords.map((record) => {
                    return (<ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} -  ${record["username"]}(${record["phone_num"]}) - ${record["precoupon_name"]}`}</ListGroupItem>);
                })}
                                    </ListGroup>
                                </div> :
            <span>삭제를 원하시는 사용자 예약권을 먼저 선택해주세요.</span>}
                        <br />
                        <br />
                        <div className="hstack gap-2 justify-content-center">
                            <Button onClick={() => { clearSelectedOptions(); togDeleteModal(); }} className="bg-gradient-light fw-medium"><i className="ri-close-line me-1 align-middle"></i> 닫기</Button>
                            <Button onClick={() => { deleteRecords(); setDeleteModal(false); }} disabled={checkedRecords.length === 0} color="danger">데이터만 취소</Button>
                            <Button onClick={() => { refundPrecoupons(); setDeleteModal(false); }} disabled={checkedRecords.length === 0} color="danger">환불하기</Button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>);
};
export default UserDetailPrecouponList;
